import { Site } from '@envato/foundation-types'

import randomNumberForToday from '../../../common/utils/randomNumberForToday'

const NUM_ITEMS = 6

const getElementsDataForSite = (site: Site) => {
  const siteData = data[site]
  const start =
    randomNumberForToday(0, siteData.data.length / NUM_ITEMS) * NUM_ITEMS
  const end = start + NUM_ITEMS

  return {
    ...siteData,
    data: siteData.data.slice(start, end)
  }
}

const data: any = {
  [Site.themeforest]: {
    title: 'Unlimited downloads',
    subtitle:
      'Unlimited access to 433,000+ stock photos and videos with Envato Elements. From $16.50/m.',
    cta: {
      title: 'Go to Envato Elements',
      url: 'https://elements.envato.com/pricing'
    },
    data: [
      {
        title: 'Fruit Shop - Organic Food, Natural Responsive Shopify Theme',
        author: 'ShopiLaunch',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/257152933/Thumbnails.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/257152934/ThemePreview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/fruit-shop-organic-food-natural-responsive-shopify-theme/full_screen_preview/21294031'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/257152934/ThemePreview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/257152934/ThemePreview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=5cf18f61778c3831032d227a12938fc3',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/fruit-shop-organic-food-natural-shopify-theme-4ZX4RLJ',
        marketID: 21294031,
        categoryName: 'CMS Templates',
        type: 'theme'
      },
      {
        title: 'Christmas Responsive Email Template + Online Builder',
        author: 'CastelLab',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/165117549/2TM.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/165117550/img/000_preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/christmas-responsive-email-template-online-builder/full_screen_preview/14247464'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/165117550/img/000_preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/165117550/img/000_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=9f930e6082c98d3018da6b42ef60447f',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/165117550/img/01_index.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=5bbb1e2ca70ce592792778309e4ee814',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/christmas-responsive-email-template-online-build-PV9Q7M',
        marketID: 14247464,
        categoryName: 'Email Templates',
        type: 'theme'
      },
      {
        title: 'AppCraft - Creative Template for Mobile App Landing Page',
        author: 'CocoTemplates',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/262948770/appcraft-thumb.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/262948771/preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/appcraft-creative-template-for-mobile-app-landing-page/full_screen_preview/23588913'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/262948771/preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/262948771/preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f89a633551aa4345802f7104569eb99b',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/appcraft-mobile-app-landing-page-JG55D57',
        marketID: 23588913,
        categoryName: 'Web Templates',
        type: 'theme'
      },
      {
        title: 'Rento - Real Estate PSD Theme',
        author: 'unyfox',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/168984627/Icon_80x80.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/168984972/Preview/00_banner_590x300.__large_preview.png'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/168984972/Preview/00_banner_590x300.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/168984972/Preview/00_banner_590x300.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=8547e6b13fdc6e0bf2746f425dc272ab',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/168984972/Preview/01_homepage.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=76f57a4fa0752115485fe7aba8a93093',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/168984972/Preview/02_homepage_2.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=8c59b7d0d69c863ce56dda6b076efbc7',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/168984972/Preview/03_homepage_3+2.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=3c01dd2b36fb6f76954f4b099c167e3f',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/168984972/Preview/04_homepage_4.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=dbe64aa9928842c4054e442abf3ef726',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL: 'https://elements.envato.com/rento-MHRJLJ',
        marketID: 14611147,
        categoryName: 'Graphic Templates',
        type: 'theme'
      },
      {
        title: 'Snac - Premium Responsive App Landing Page PSD Template',
        author: 'AuThemes',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/230819259/logo.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/230819261/Preview/01_Preview.__large_preview.jpg'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/230819261/Preview/01_Preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/230819261/Preview/01_Preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=7378142aa4f4bd6f28d14a1a595e9d87',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/230819261/Preview/02_Home_Page.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=aa8dc90d43fc7ac1676c01bb75d0885a',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/snac-premium-responsive-app-landing-page-J9WDNW',
        marketID: 20380691,
        categoryName: 'Web Templates',
        type: 'theme'
      },
      {
        title: 'Materialart Powerful Material Admin Template',
        author: 'MARUTI',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/253265187/thumb.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/253265188/preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/materialart-powerful-material-admin-template/full_screen_preview/22511427'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/253265188/preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/253265188/preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=fd1e72c6360cc9ac3f5d8cd3257f133f',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/materialart-powerful-material-admin-template-TXQA4RM',
        marketID: 22511427,
        categoryName: 'Admin Templates',
        type: 'theme'
      },
      {
        title: 'Digital Agency - SEO / Marketing HTML Template',
        author: 'suniljoshi',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/196016147/digital-agency-html-thumb.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/196016151/Preview-Digital-Agency/screen01.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/digital-agency-seo-marketing-html-template/full_screen_preview/16666590'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/196016151/Preview-Digital-Agency/screen01.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/196016151/Preview-Digital-Agency/screen01.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=b85125798aab07dac5768829dc66e52c',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/digital-agency-seo-marketing-html-template-377MKK',
        marketID: 16666590,
        categoryName: 'Web Templates',
        type: 'theme'
      },
      {
        title: 'Roka - Recipes and Food Plan App UI Kit',
        author: 'betush',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/276489737/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/276489738/01_roka.__large_preview.jpg'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/276489738/01_roka.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/276489738/01_roka.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=cf3eeeb7e6a37c3d7dffcd6aa34e6323',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/276489738/02_roka.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f0d059aa799a6890c44f333fff16a42e',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/roka-recipes-and-food-plan-app-ui-kit-RNCX3R2',
        marketID: 23662194,
        categoryName: 'Graphic Templates',
        type: 'theme'
      },
      {
        title: 'Maxima - Minimal Blog and Magazine Jekyll Theme',
        author: 'aspirethemes',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/223141731/%20Thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/223141734/theme_preview/maxima-theme-preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/maxima-minimal-blog-magazine-ghost-theme/full_screen_preview/19164859'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/223141734/theme_preview/maxima-theme-preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/223141734/theme_preview/maxima-theme-preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=f0733d9c48db0f279021adbfc4cbf661',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/maxima-minimal-blog-and-magazine-jekyll-theme-PWV5BD',
        marketID: 19164859,
        categoryName: 'Web Templates',
        type: 'theme'
      },
      {
        title: 'Upking - Hiking Club WordPress Theme',
        author: 'themeton',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/279228603/upking-80x80.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/279228604/preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/upking-hiking-club-wordpress-theme/full_screen_preview/21348987'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/279228604/preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/279228604/preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=3f5676012e89626df92d3fd14f8809d4',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/upking-hiking-club-wordpress-theme-WWXLMJV',
        marketID: 21348987,
        categoryName: 'WordPress Themes',
        type: 'theme'
      },
      {
        title: 'Boscona - Minimal One Column Theme',
        author: 'thejenyuan',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/104286603/Boscona%20Icon.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/104286605/Cover.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/boscona-minimal-one-column-theme/full_screen_preview/8842342'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/104286605/Cover.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/104286605/Cover.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=6b9fe7e583f848f9f98dc2faba15589a',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/104286605/Screenshot+01.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=4b115dd91d87b0fbb71d0a5276e1d993',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/104286605/Screenshot+02.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=6dc4e12feeffdcfcd9b8a63328b514d3',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/104286605/Screenshot+03.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=4e3d50e1ebb5998a7a600b559c62966e',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/boscona-minimal-one-column-theme-SLLRYX',
        marketID: 8842342,
        categoryName: 'CMS Templates',
        type: 'theme'
      },
      {
        title: 'Vanessa Easy Startup Landing Page',
        author: 'xvelopers',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/183303601/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/183303605/preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/vanessa-easy-startup-landing-page/full_screen_preview/15877688'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/183303605/preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/183303605/preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=9d300243c92a0b91115f593c923a8aab',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/vanessa-easy-startup-landing-page-HXGYQT',
        marketID: 15877688,
        categoryName: 'CMS Templates',
        type: 'theme'
      },
      {
        title: 'HomeProtect - Smart Alarm & Security Systems PSD Template',
        author: 'Layerdrops',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/258612585/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/258612590/previews/01_Preview.__large_preview.jpg'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/258612590/previews/01_Preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/258612590/previews/01_Preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=092a3ffaca3fde60fb00c2b36a0370b9',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/258612590/previews/02_Home.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=c8ba9251b7e87a043f862a3d58016685',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/258612590/previews/03_Home.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=bd0c14f469902f3892ae83f3ea135aa7',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/258612590/previews/04_Home.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=c9e2795086b8faa28c516e88eaa1447a',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/258612590/previews/05_Home.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=50fddce3a1acb8988678e2a35971d8a0',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/homeprotect-smart-alarm-security-systems-psd-VK8JTM',
        marketID: 22341528,
        categoryName: 'Graphic Templates',
        type: 'theme'
      },
      {
        title: 'Ikar - Blog/Magazine HTML Template',
        author: 'unyfox',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/206796971/Ikar-80x80.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/206796972/00_banner_590x300_html.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/ikar-blogmagazine-html-template/full_screen_preview/18101081'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/206796972/00_banner_590x300_html.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/206796972/00_banner_590x300_html.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=fdf4f51d8c23715ba297f18c4d92a519',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL: 'https://elements.envato.com/ikar-html-MJ2BDS',
        marketID: 18101081,
        categoryName: 'Web Templates',
        type: 'theme'
      },
      {
        title: 'Wiggo - Multi-Concept HTML Template',
        author: 'shtheme',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/217545522/Thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/217545523/theme-preview/Image_preview.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/wiggo-multiconcept-html-template/full_screen_preview/17511874'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/217545523/theme-preview/Image_preview.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/217545523/theme-preview/Image_preview.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=e906628f1406f5b9ec4d3f286650bb24',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/217545523/theme-preview/Thumbnail.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=4f988a43682d372484a80d834fbfd1af',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/wiggo-multi-concept-html-template-7TSMLN5',
        marketID: 17511874,
        categoryName: 'Web Templates',
        type: 'theme'
      },
      {
        title: 'Vloma Grid - A Responsive WordPress Video Blog Theme',
        author: 'An-Themes',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/287279678/Thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/287279679/Screenshots/01_preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/vloma-grid-a-responsive-wordpress-video-blog-theme/full_screen_preview/19475843'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/287279679/Screenshots/01_preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/287279679/Screenshots/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=09bc64da40e3503d8ca13b0497a848ef',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/vloma-grid-blog-magazine-video-wordpress-theme-U43VW2U',
        marketID: 19475843,
        categoryName: 'WordPress Themes',
        type: 'theme'
      },
      {
        title: 'Helpmate - 6 in 1 Maintenance Drupal Theme',
        author: 'ArrowHiTech',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/203841867/00_icon.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/203841868/01_preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/helpmate-6-in-1-maintenance-drupal-theme/full_screen_preview/17496966'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/203841868/01_preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/203841868/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=5cae7935be1e1de61756c265ec2ac814',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/helpmate-6-in-1-maintenance-drupal-theme-5V3Z9M',
        marketID: 17496966,
        categoryName: 'CMS Templates',
        type: 'theme'
      },
      {
        title: 'RE - Multi-purpose Responsive Muse Templates',
        author: 'Rometheme',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/241379044/Thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/242028439/Preview%20image/preview-image.__large_preview.png'
          },
          live_site: {
            url:
              'https://themeforest.net/item/re-multipurpose-responsive-muse-templates/full_screen_preview/21292523'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/242028439/Preview%20image/preview-image.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/242028439/Preview+image/preview-image.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=b7917a5a6b4470190ab1770c4263aaac',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/re-multi-purpose-responsive-muse-templates-yr-9XQZES',
        marketID: 21292523,
        categoryName: 'CMS Templates',
        type: 'theme'
      },
      {
        title: 'EVERY - Creative Onepage PSD Template',
        author: 'Fami_Themes',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/132877054/Thumbnail.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/132877063/Theme_Preview/01_preview_590x300.__large_preview.png'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/132877063/Theme_Preview/01_preview_590x300.__large_preview.png',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/132877063/Theme_Preview/01_preview_590x300.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=0cf6405d442211b28eba635e8b92723c',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/132877063/Theme_Preview/02_Homepage_every.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=5be147653c05e00c4e888909ac4c1386',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/132877063/Theme_Preview/03_blog_sidebar.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=d9cd329a817bb41ca63bd897299fa43d',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/132877063/Theme_Preview/04_blog_sidebar_single_post.png?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=7671adcfd7f8532bd792055488755af3',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/every-creative-onepage-psd-template-2AV297',
        marketID: 11311353,
        categoryName: 'Graphic Templates',
        type: 'theme'
      },
      {
        title: 'LiveKitchen - HTML5 Restaurant Template',
        author: 'HTMLguru',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/223514659/thumbnail.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/223514661/preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/livekitchen-html5-restaurant-template/full_screen_preview/19644472'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/223514661/preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/223514661/preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=8faa8c4ff7a36b1402d24911bb731ef4',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL: 'https://elements.envato.com/livekitchen-FW9SUW',
        marketID: 19644472,
        categoryName: 'Web Templates',
        type: 'theme'
      },
      {
        title: 'Aspero - Business WordPress Theme',
        author: 'cmsmasters',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/257167014/aspero-icon.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/257433867/01_aspero-preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/aspero-business-wordpress-theme/full_screen_preview/22226666'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/257433867/01_aspero-preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/257433867/01_aspero-preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=90d103945ba5914aa398c626d1d47f02',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/aspero-business-wordpress-theme-XGR75LB',
        marketID: 22226666,
        categoryName: 'WordPress Themes',
        type: 'theme'
      },
      {
        title: 'Stilo - Creative Parallax One Page MUSE Template',
        author: 'Muse-Master',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/124171907/thumbnail.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/124171908/preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/stilo-creative-parallax-one-page-muse-template/full_screen_preview/10571397'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/124171908/preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/124171908/preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=cd71d1651cdc522efbddd4287c540103',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/stilo-creative-parallax-one-page-muse-template-TALVP9',
        marketID: 10571397,
        categoryName: 'CMS Templates',
        type: 'theme'
      },
      {
        title: 'ProDJ - Creative DJ / Producer Site PSD Template',
        author: 'vinyljunkie',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/236210579/thumb.jpg',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/236210600/01_preview.__large_preview.jpg'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/236210600/01_preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/236210600/01_preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=bbe608eeb18416e2432135c3191e7d84',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/236210600/02_preview_desktop.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=8961fb5b9b21c95e6999b8fbab925542',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/236210600/03_preview_mobile.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=a202c2dacc91f3b8546e6b1bb0787ba7',
                width: 590,
                height: 300
              },
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/236210600/04_preview_tablet.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=33c255717f362cf507bf9243257a4bda',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/prodj-creative-dj-producer-site-psd-template-H8EMKN',
        marketID: 20906911,
        categoryName: 'Graphic Templates',
        type: 'theme'
      },
      {
        title: 'Handyman - Job Board HTML Template',
        author: 'dan_fisher',
        previews: {
          icon_with_landscape_preview: {
            icon_url:
              'https://previews.customer.envatousercontent.com/files/175233812/thumb.png',
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/175233813/preview.__large_preview.jpg'
          },
          live_site: {
            url:
              'https://themeforest.net/item/handyman-job-board-html-template/full_screen_preview/11620086'
          },
          landscape_preview: {
            landscape_url:
              'https://previews.customer.envatousercontent.com/files/175233813/preview.__large_preview.jpg',
            image_urls: [
              {
                name: null,
                url:
                  'https://themeforest.img.customer.envatousercontent.com/files/175233813/preview.jpg?auto=compress%2Cformat&fit=crop&crop=top&w=590&h=300&s=57e80546beca8867bee68adbdc7793f4',
                width: 590,
                height: 300
              }
            ]
          }
        },
        itemURL:
          'https://elements.envato.com/handyman-job-board-html-template-WRF7C8',
        marketID: 11620086,
        categoryName: 'Web Templates',
        type: 'theme'
      }
    ]
  }
}

export default getElementsDataForSite
